// src/components/Hero.js
import React, { useEffect, useRef, useState } from 'react';
import ShapeDivider from './ShapeDivider';
import heroVideo from '../assets/hero-video.mp4'; // Import your video file

const Hero = () => {
  const heroRef = useRef(null);
  const headingRef = useRef(null);
  const subheadingRef = useRef(null);
  const buttonRef = useRef(null);
  const videoRef = useRef(null);

  const [content, setContent] = useState({
    title: 'Welcome to Three Leaf Food & Beverages Trading L.L.C',
    subtitle: 'Your Complete Ingredients Solution Partner',
    body: `At Three Leaf, we don’t just supply ingredients — we deliver value, consistency, and innovation. 
    With a robust global sourcing network and a deep understanding of regional markets, we connect the world’s finest food and beverage ingredients with businesses across the GCC and Middle East. 

    Whether you’re developing a new product line or optimizing existing recipes, we provide premium, reliable, and tailored solutions that help you stay ahead of consumer trends while ensuring seamless supply chains.`
  });

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animated');
          // Play video when in view
          if (entry.target === heroRef.current && videoRef.current) {
            videoRef.current.play().catch(e => console.log("Autoplay prevented:", e));
          }
        }
      });
    }, { threshold: 0.1 });

    if (heroRef.current) observer.observe(heroRef.current);
    if (headingRef.current) observer.observe(headingRef.current);
    if (subheadingRef.current) observer.observe(subheadingRef.current);
    if (buttonRef.current) observer.observe(buttonRef.current);

    return () => {
      if (heroRef.current) observer.unobserve(heroRef.current);
      if (headingRef.current) observer.unobserve(headingRef.current);
      if (subheadingRef.current) observer.unobserve(subheadingRef.current);
      if (buttonRef.current) observer.unobserve(buttonRef.current);
    };
  }, []);

  // Hero content is now static and managed by developers
  // No API call needed

  return (
    <section id="home" className="hero-section" ref={heroRef}>
      <div className="video-container">
  <video ref={videoRef} autoPlay muted loop playsInline className="hero-video">
    <source src={heroVideo} type="video/mp4" />
  </video>
  <div className="video-overlay"></div>
</div>
      
      <div className="container hero-container">
        <div className="glass-card">
          <div className="hero-content">
            <h1 
              className="animate-on-scroll slide-in-left" 
              ref={headingRef}
            >
              {content.title}
            </h1>
            <p 
              className="animate-on-scroll slide-in-right delay-1" 
              ref={subheadingRef}
            >
              {content.subtitle}
            </p>
            <p 
              className="animate-on-scroll fade-in delay-2" 
              ref={subheadingRef}
            >
              {content.body}
            </p>
            <div className="animate-on-scroll fade-in delay-3" ref={buttonRef}>
              <a href="#contact" className="btn glass-btn">Get in Touch</a>
            </div>
          </div>
        </div>
      </div>
      <ShapeDivider />
    </section>
  );
};

export default Hero;